/**
 * 筋特征预览执行器。
 */

import type { WorkerManager } from '../../../../worker';
import type { RibFeatureDefinitionModel } from '../../../definition/rib/RibFeatureDefinition';
import type { FeatureEditSession } from '../../../edit/FeatureEditSession';
import { FeaturePreviewExecution } from '../FeaturePreviewExecution';

/**
 * 筋特征预览执行器。
 */
export class RibPreviewExecution extends FeaturePreviewExecution<RibFeatureDefinitionModel> {
    /** Worker 管理器。 */
    private readonly workerManager: WorkerManager;

    /**
     * @param workerManager Worker 管理器。
     */
    public constructor(workerManager: WorkerManager) {
        super();
        this.workerManager = workerManager;
    }

    /**
     * @inheritdoc
     */
    public async executeCreatePreview(definition: RibFeatureDefinitionModel): Promise<WorkerFeaturePreviewResult> {
        return this.workerManager.generateRibPreview(definition.getCommandParams());
    }

    /**
     * @inheritdoc
     */
    public async executeEditPreview(
        session: FeatureEditSession<RibFeatureDefinitionModel>,
        definition: RibFeatureDefinitionModel,
    ): Promise<WorkerFeaturePreviewResult> {
        return this.workerManager.generateRibPreviewInSandbox({
            commands: session.getPreviewCommands(),
            params: definition.getCommandParams(),
        });
    }
}
